import { render, staticRenderFns } from "./ComponentLargeExposure.vue?vue&type=template&id=29bf2f8e&scoped=true"
import script from "./ComponentLargeExposure.vue?vue&type=script&lang=js"
export * from "./ComponentLargeExposure.vue?vue&type=script&lang=js"
import style0 from "./ComponentLargeExposure.vue?vue&type=style&index=0&id=29bf2f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bf2f8e",
  null
  
)

export default component.exports